<template>
  <div class="didi-tip-wrapper">
    <!--  tips -->

    <div class="tips">
      <template v-if="flag==1" >
        您当前的版本过低，请升级到最新版本。<br>
        升级方式: 我的->设置->关于->版本更新
      </template>
      <template v-else >
        您当前暂无权限使用企业版打车
        <br />
        如有疑问请联系：cw-baoxiao@360.cn
      </template>
    </div>
    <van-button class="button" @click="goBack()" type="primary">返回</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag: 0 , // 0 滴滴提示  1 扫码结果
    };
  },
  watch: {
    '$route'(){
      this.flag = this.$route.meta.flag || this.flag;
    }
  },
  created(){
    this.flag = this.$route.meta.flag || this.flag;
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      if(iqh.closeWindow){
        iqh.closeWindow(1)
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.didi-tip-wrapper {
  background-color: #f7f8f9;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 100px;
  text-align: center;
  font-size: 14px;
  color: #333;
  line-height: 30px;
  .button {
    margin-top: 100px;
    width: 120px;
    cursor: pointer;
  }
}
</style>
